<div class="container">
  <div class="row">
    <div class="col-12 col-md-4" *ngFor="let plan of this.planes.data.products; let i = index">
      <div [ngClass]="
          plan.code === 'MOTOS_PlanPremium'
            ? 'card__sombreado-mayor'
            : 'card__sombreado-propio'
        " class="card estiloCard">
        <div class="card-body cardPlan" [class.cardPlan--abierta]="detalleAbierto(plan)">
          <!-- Distintivo del plan -->
          <div class="cardPlan__distintivo" *ngIf="presentacionDe(plan) as presentacion">
            <span class="cardPlan__distintivoTexto"
              [ngClass]="'cardPlan__distintivoTexto--' + presentacion.tono">
              {{ presentacion.distintivo }}
            </span>
          </div>

          <h3 class="cardPlan__nombre">{{ plan.name }}</h3>

          <p class="cardPlan__precio">
            <span class="cardPlan__precioValor">
              ${{ precioDelPlan(plan) | customNumberFormat }}
            </span>
            <span class="cardPlan__precioPeriodo">
              / {{ this.tipoPagoPlan === 'Monthly' ? 'mensual' : 'anual' }}
            </span>
          </p>

          <p class="cardPlan__descripcion" *ngIf="presentacionDe(plan) as presentacion">
            {{ presentacion.descripcion }}
          </p>

          <!-- Contrae el detalle (solo mobile, con el detalle abierto) -->
          <button type="button" class="cardPlan__verDetalles cardPlan__verDetalles--arriba" (click)="alternarDetalle(plan)"
            [attr.aria-expanded]="detalleAbierto(plan)" [attr.aria-controls]="'detallePlan-' + tipoPagoPlan + '-' + i">
            <span>Ver detalles</span>
            <svg class="cardPlan__verDetallesFlecha" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              aria-hidden="true">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>

          <!-- Vista resumida (solo mobile, con el detalle cerrado) -->
          <div class="cardPlan__resumen" *ngIf="resumenDelPlan(plan).length > 0">
            <h4 class="cardPlan__resumenTitulo">Principales coberturas y asistencias:</h4>
            <ul class="cardPlan__resumenLista">
              <li class="cardPlan__resumenItem" *ngFor="let etiqueta of resumenDelPlan(plan)">{{ etiqueta }}</li>
            </ul>
          </div>

          <!-- Detalle completo (en mobile solo con el detalle abierto) -->
          <div class="cardPlan__soloDetalle" [id]="'detallePlan-' + tipoPagoPlan + '-' + i">
            <!-- Coberturas -->
            <ng-container *ngIf="coberturasDelPlan(plan).length > 0">
              <h4 class="cardPlan__tituloGrupo">Coberturas</h4>
              <ul class="cardPlan__lista">
                <li class="cardPlan__item" *ngFor="let item of coberturasDelPlan(plan)">
                  <img src="./assets/img/iconoVineta.png" alt="" aria-hidden="true"
                    class="cardPlan__check" />
                  <span class="cardPlan__itemTexto">{{ item.texto
                    }}<span class="cardPlan__destacado" *ngIf="item.destacado">{{ item.destacado }}</span></span>
                </li>
              </ul>
            </ng-container>

            <!-- Asistencias -->
            <ng-container *ngIf="asistenciasDelPlan(plan).length > 0">
              <h4 class="cardPlan__tituloGrupo">Asistencias</h4>
              <ul class="cardPlan__lista">
                <li class="cardPlan__item" *ngFor="let item of asistenciasDelPlan(plan)">
                  <img src="./assets/img/iconoVineta.png" alt="" aria-hidden="true"
                    class="cardPlan__check" />
                  <span class="cardPlan__itemTexto">{{ item.texto
                    }}<span class="cardPlan__destacado" *ngIf="item.destacado">{{ item.destacado }}</span></span>
                </li>
              </ul>
            </ng-container>

            <!-- Este plan no incluye -->
            <ng-container *ngIf="exclusionesDelPlan(plan).length > 0">
              <h4 class="cardPlan__tituloGrupo">Este plan no incluye</h4>
              <ul class="cardPlan__lista">
                <li class="cardPlan__item" *ngFor="let item of exclusionesDelPlan(plan)">
                  <img src="./assets/img/iconoVinetaNo.png" alt="" aria-hidden="true"
                    class="cardPlan__check" />
                  <span class="cardPlan__itemTexto">{{ item.texto
                    }}<span class="cardPlan__destacado" *ngIf="item.destacado">{{ item.destacado }}</span></span>
                </li>
              </ul>
            </ng-container>
          </div>

          <!-- Franja de asistencias para alto cilindraje -->
          <div class="cardPlan__franja" *ngIf="presentacionDe(plan)?.franjaAltoCilindraje && esAltoCilindraje">
            <img src="./assets/img/svg/Certificado.svg" alt="" aria-hidden="true"
              class="cardPlan__franjaIcono" />
            <span>{{ FRANJA_ALTO_CILINDRAJE }}</span>
          </div>

          <!-- Cobertura opcional: Perdidas parciales -->
          <div class="coberturaOpcional" *ngIf="ofreceCoberturaOpcional(plan)">
            <span class="coberturaOpcional__titulo">Cobertura opcional</span>

            <div class="coberturaOpcional__fila">
              <label class="switch">
                <input class="switch__input" type="checkbox" [id]="'perdidaParcial-' + tipoPagoPlan + '-' + i"
                  [checked]="perdidaParcialSeleccionada"
                  (change)="onTogglePerdidaParcial($any($event.target).checked)" />
                <span class="switch__pista"></span>
              </label>
              <span class="coberturaOpcional__nombre">Pérdidas parciales</span>
            </div>

            <p class="coberturaOpcional__detalle">
              Si arreglar tu moto cuesta menos del 75% de su valor, te cubrimos:<br />
              Bajo cilindraje: deducible de 0,5 SMLMV.<br />
              Alto cilindraje: deducible del 20% o 2 SMLMV.
            </p>
          </div>

          <!-- Abre el detalle (solo mobile, con el detalle cerrado) -->
          <button type="button" class="cardPlan__verDetalles cardPlan__verDetalles--abajo" (click)="alternarDetalle(plan)"
            [attr.aria-expanded]="detalleAbierto(plan)" [attr.aria-controls]="'detallePlan-' + tipoPagoPlan + '-' + i">
            <span>Ver detalles</span>
            <svg class="cardPlan__verDetallesFlecha" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              aria-hidden="true">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>

          <button gtagEvent class="btn btn-primary w-100 py-2 boton cardPlan__cta" type="submit" trackOn="click"
            action="standaloneTrue" (click)="ResumenPlan(i)">
            Elegir plan
          </button>

          <div class="tipoLetraCondiciones cardPlan__condicionado cardPlan__soloDetalle">
            Ver el <a *ngIf="this.planes" (click)="openCondicionado()" class="condicionado-link">condicionado</a>
            para mayor información
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>
</div>
